<template>
<div>
    <section>
        <div>
            <a href="https://goo.gl/maps/sEXL2nU8rv2dwafD9" target="_blank">
            <img src="/img/brand/bando1.png" style="width: 100%; height: auto;"></a>
        </div>
        <div class="container">
            <div class="row row-grid justify-content-center">
                    <div class="text-center mb-5 mt-5">
                        <h5 style="color: #8898aa !important;"> Hotline: (+84) 2435 567 567 </h5>
                        <h5 style="color: #8898aa !important;"> Địa chỉ: Số 10, ngõ 1, phố Đỗ Quang, phường Trung Hòa, quận Cầu Giấy Hà Nội</h5>
                    </div>
            </div>
        </div>
    </section>
<!--
    <section class="display-4 mb-5 mt-5">
        <div class="container">
            <div class="row row-grid justify-content-center">
                    <div class="text-center">
                        <h4 class="display-4 mb-5 mt-5">Đối Tác</h4>
                        <div class="row justify-content-center">
                            <div class="col-lg-2 col-4">
                                <a href="#" target="_blank" data-toggle="tooltip" data-original-title="Bootstrap 4 - Most popular front-end component library">
                                    <img src="img/brand/funtap.png" class="img-fluid " >
                                </a>
                            </div>
                            <div class="col-lg-2 col-4">
                                <a href="#" target="_blank" data-toggle="tooltip" data-original-title="[Coming Soon] Sketch - Digital design toolkit">
                                    <img src ="img/brand/garena.png" class="img-fluid ">
                                </a>
                            </div>
                            <div class="col-lg-2 col-4">
                                <a href="#" data-toggle="tooltip" data-original-title="[Coming Soon] Adobe Photoshop - Software for digital images manipulation">
                                    <img src ="img/brand/gmobile.png" class="img-fluid ">
                                </a>
                            </div>
                            <div class="col-lg-2 col-4">
                                <a href="#" target="_blank" data-toggle="tooltip" data-original-title="Vue.js - The progressive javascript framework">
                                    <img src ="img/brand/mobifone.png" class="img-fluid">
                                </a>
                            </div>
                            <div class="col-lg-2 col-4">
                                <a href="#" target="_blank" data-toggle="tooltip" data-original-title="[Coming Soon] Angular - One framework. Mobile &amp; desktop">
                                    <img src = "img/brand/viettel - Copy.png" class="img-fluid ">
                                </a>
                            </div>
                            <div class="col-lg-2 col-4">
                                <a href="#" target="_blank" data-toggle="tooltip" data-original-title="[Coming Soon] React - A JavaScript library for building user interfaces">
                                    <img src = "img/brand/vinaphone.png" class="img-fluid ">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       
    </section>
    -->
</div>
</template>
<script>
export default {};
</script>
<style>

</style>
